// src/AudioSpectrum/effects/circularWave.js
import { getHSLColor } from '../colorUtils.js';

export const drawCircularWave = (ctx, frequencyData, width, height) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const maxRadius = Math.min(width, height) / 2 - 20;
  
  ctx.clearRect(0, 0, width, height);
  
  const rings = 5;
  const barCount = Math.min(frequencyData.length / rings, 32);
  
  for (let ring = 0; ring < rings; ring++) {
    const baseRadius = (ring + 1) * (maxRadius / rings);
    ctx.beginPath();
    
    for (let i = 0; i <= barCount; i++) {
      const value = frequencyData[ring * barCount + i] || 0;
      const angle = (i / barCount) * Math.PI * 2;
      const radius = baseRadius + (value / 255) * 20;
      
      const x = centerX + Math.cos(angle) * radius;
      const y = centerY + Math.sin(angle) * radius;
      
      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }
    
    ctx.closePath();
    ctx.strokeStyle = getHSLColor(ring * 60, 100, 50);
    ctx.lineWidth = 2;
    ctx.stroke();
  }
};